import { Title } from '@angular/platform-browser';
import { Subscription } from 'rxjs/Subscription';
import { timer } from 'rxjs/observable/timer';
import { AuthService } from '../../services/authentication/auth.service';
import { VERSION_NUMBER } from '../../services/version/version.service';
var OfflineComponent = /** @class */ (function () {
    function OfflineComponent(authSvc, titleSvc) {
        var _this = this;
        this.authSvc = authSvc;
        this.titleSvc = titleSvc;
        this._subrelease = new Subscription();
        this.ShowingUpdate = false;
        this.TimerMax = 60;
        this.TimerCount = this.TimerMax;
        this.titleSvc.setTitle('DELTA | System Current Unavailable');
        // Set up a subscription on Test Connection, to check for the system being available while waiting for it to resume.
        // If the user isn't logged in and we detect a new version is available, silently go ahead and reload.
        this.subrelease = timer(0, 1000).subscribe(function (_) {
            _this.TimerCount--;
            if (_this.TimerCount === 0) {
                // Call out to test the connection.
                _this.authSvc.TestConnection().subscribe(function (result) {
                    // Update the status.
                    _this.authSvc.SetSystemOnlineStatus(result);
                    // And reset the tick count.
                    _this.TimerCount = _this.TimerMax;
                }, function (err) {
                    _this.authSvc.SetSystemOnlineStatus({
                        Status: false,
                        SystemMessage: '',
                        DeltaVersion: VERSION_NUMBER,
                    });
                });
            }
        });
    }
    Object.defineProperty(OfflineComponent.prototype, "subrelease", {
        set: function (sub) {
            this._subrelease.add(sub);
        },
        enumerable: true,
        configurable: true
    });
    OfflineComponent.prototype.ngOnDestroy = function () {
        this._subrelease.unsubscribe();
    };
    return OfflineComponent;
}());
export { OfflineComponent };



// WEBPACK FOOTER //
// ./src/app/offline/offline.component.ts.pre-build-optimizer.js